var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_warehouse"},[_c('div',{staticClass:"bg-breadcrumb"},[_c('img',{attrs:{"src":_vm.img}})]),_c('span',[_vm._v(_vm._s(_vm.goLang(_vm.name)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }